
import { Get } from "domain/infra/data/api"
import { CarteiraBaseResponse } from "../../types/carteiraBase/carteiraBaseResponse"
import { CarteiraBaseCampanhaResponse } from "../../types/carteiraBase/carteiraBaseCampanhaResponse"
import { CarteiraUsuarioResponse } from "../../types/carteiraBase/carteiraUsuarioResponse"
import DomainConstants from "../../infra/data/domainConstants";

export class CarteiraBaseService {
  constructor() {
    //super()
  }

  async GetCarteiraBase(carteiraId: number): Promise<CarteiraBaseResponse | Error> {
    return await Get(DomainConstants.apiDomain.carteira.getUserInfo(carteiraId))
  }

  async GetCarteiraBasePorCarteira(carteiraId: number, campanhaId: number): Promise<CarteiraBaseCampanhaResponse[] | Error> {
    return await Get(`${DomainConstants.apiDomain.carteira.getUserInfoCampanha(carteiraId)}?campanhaID=${campanhaId}`);
  }

  async GetCarteiraUsuario(usuarioId: number, empresaId: number): Promise<CarteiraUsuarioResponse[] | Error> {
    return await Get(`${DomainConstants.apiDomain.carteira.getCarteiraUsuario}?usuarioID=${usuarioId}&empresaID=${empresaId}`);
  }
}
